import React from 'react';
import {ReactComponent as SearchIcon} from '../../../../images/not-find.svg';
import {ReactComponent as EmptyListIcon} from '../../../../images/empty-list.svg';
import {Text} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';

type Props = {
    search: string;
    emptySearchText?: string;
    emptyDataText?: string;
    componentClasses?: string;
};
export const EmptyListMessage = ({
    search,
    emptyDataText,
    emptySearchText,
    componentClasses
}: Props) => {
    return search.length ? (
        <div className={cx(styles.pictureContainer)}>
            <SearchIcon />
            {emptySearchText && (
                <Text tag="p" skin="caption-2" textColor="primary-700">
                    {emptySearchText}
                </Text>
            )}
        </div>
    ) : (
        <div className={cx(styles.pictureContainer, componentClasses)}>
            <EmptyListIcon />
            {emptyDataText && (
                <Text skin="caption-2" textColor="primary-700" tag="p">
                    {emptyDataText}
                </Text>
            )}
        </div>
    );
};
